import React from 'react'


const Intro = () => {

  // const cookie = document.cookie.split("; ").find((row) => row.startsWith("welcomeTo"));

  return (
    <>
      {

        // !cookie

        //   ?

        //   <div id="intro">
        //     <div className="video__container">


        //       <button type="button" id="enter">Enter Site</button>

        //       <video className="video" width="320" height="240" controls autoPlay muted>
        //         <source src="images/intro.mp4" type="video/mp4" />
        //       </video>


        //     </div>
        //   </div >

        //   :

        <div className="splash__screen ">
          <h1 className="splash__header">
            <span className="greeting blank__space">Blaze </span><span className="greeting"> Up.</span>
          </h1>
        </div>
      }
    </>
  )
}




export default Intro;